export type BillingCycle = 'monthly' | 'yearly';

export type PlanId =
  | 'starter_5'
  | 'family_10'
  | 'extended_30';

export type KinsSpacePackId =
  | 'kinsspace_100'
  | 'kinsspace_250'
  | 'kinsspace_500'
  | 'kinsspace_1tb'
  | 'kinsspace_2tb';

export interface MembershipPlan {
  id: PlanId;
  name: string;
  tagline: string;

  monthlyPrice: number;
  yearlyPrice: number;

  seats: number;

  includedKinsSpaceGB: number;

  uploadLimitMB: number;

  stripeMonthlyEnv: string;
  stripeYearlyEnv: string;
}

export interface KinsSpacePack {
  id: KinsSpacePackId;

  name: string;

  storageGB: number;

  monthlyPrice: number;
  yearlyPrice: number;

  stripeMonthlyEnv: string;
  stripeYearlyEnv: string;
}

export const MEMBERSHIP_PLANS: Record<PlanId, MembershipPlan> = {

  starter_5: {
    id: 'starter_5',
    name: 'Starter',
    tagline: 'Build your family foundation.',

    monthlyPrice: 7.99,
    yearlyPrice: 79.99,

    seats: 5,

    includedKinsSpaceGB: 10,

    uploadLimitMB: 50,

    stripeMonthlyEnv: 'VITE_STRIPE_PRICE_STARTER_MONTHLY',
    stripeYearlyEnv: 'VITE_STRIPE_PRICE_STARTER_YEARLY',
  },

  family_10: {
    id: 'family_10',
    name: 'Family',
    tagline: 'Perfect for growing families.',

    monthlyPrice: 14.99,
    yearlyPrice: 149.99,

    seats: 10,

    includedKinsSpaceGB: 100,

    uploadLimitMB: 250,

    stripeMonthlyEnv: 'VITE_STRIPE_PRICE_FAMILY_MONTHLY',
    stripeYearlyEnv: 'VITE_STRIPE_PRICE_FAMILY_YEARLY',
  },

  extended_30: {
    id: 'extended_30',
    name: 'Extended Family',
    tagline: 'Multi-generation family preservation.',

    monthlyPrice: 24.99,
    yearlyPrice: 249.99,

    seats: 30,

    includedKinsSpaceGB: 500,

    uploadLimitMB: 1024,

    stripeMonthlyEnv: 'VITE_STRIPE_PRICE_EXTENDED_MONTHLY',
    stripeYearlyEnv: 'VITE_STRIPE_PRICE_EXTENDED_YEARLY',
  },

};

export const KINSSPACE_PACKS: Record<KinsSpacePackId, KinsSpacePack> = {

  kinsspace_100: {
    id:'kinsspace_100',
    name:'KinsSpace +100 GB',
    storageGB:100,
    monthlyPrice:4.99,
    yearlyPrice:49.99,
    stripeMonthlyEnv:'VITE_STRIPE_PRICE_KINSSPACE100_MONTHLY',
    stripeYearlyEnv:'VITE_STRIPE_PRICE_KINSSPACE100_YEARLY'
  },

  kinsspace_250: {
    id:'kinsspace_250',
    name:'KinsSpace +250 GB',
    storageGB:250,
    monthlyPrice:9.99,
    yearlyPrice:99.99,
    stripeMonthlyEnv:'VITE_STRIPE_PRICE_KINSSPACE250_MONTHLY',
    stripeYearlyEnv:'VITE_STRIPE_PRICE_KINSSPACE250_YEARLY'
  },

  kinsspace_500: {
    id:'kinsspace_500',
    name:'KinsSpace +500 GB',
    storageGB:500,
    monthlyPrice:17.99,
    yearlyPrice:179.99,
    stripeMonthlyEnv:'VITE_STRIPE_PRICE_KINSSPACE500_MONTHLY',
    stripeYearlyEnv:'VITE_STRIPE_PRICE_KINSSPACE500_YEARLY'
  },

  kinsspace_1tb: {
    id:'kinsspace_1tb',
    name:'KinsSpace +1 TB',
    storageGB:1000,
    monthlyPrice:29.99,
    yearlyPrice:299.99,
    stripeMonthlyEnv:'VITE_STRIPE_PRICE_KINSSPACE1TB_MONTHLY',
    stripeYearlyEnv:'VITE_STRIPE_PRICE_KINSSPACE1TB_YEARLY'
  },

  kinsspace_2tb: {
    id:'kinsspace_2tb',
    name:'KinsSpace +2 TB',
    storageGB:2000,
    monthlyPrice:49.99,
    yearlyPrice:499.99,
    stripeMonthlyEnv:'VITE_STRIPE_PRICE_KINSSPACE2TB_MONTHLY',
    stripeYearlyEnv:'VITE_STRIPE_PRICE_KINSSPACE2TB_YEARLY'
  }

};

export function pricePerSeat(plan: MembershipPlan){

  return Number(
    (plan.monthlyPrice/plan.seats).toFixed(2)
  );

}

export function formattedSeatValue(plan: MembershipPlan){

  return `About $${pricePerSeat(plan).toFixed(2)} per family seat each month`;

}

export function totalKinsSpace(plan:PlanId,packs:KinsSpacePackId[]=[]){

  return MEMBERSHIP_PLANS[plan].includedKinsSpaceGB+
    packs.reduce((a,p)=>a+(KINSSPACE_PACKS[p]?.storageGB ?? 0),0);

}

export const BUSINESS_POLICY={

  graceDays:7,

  uploadWarningDay:15,

  readOnlyDay:30,

  preserveMemories:true,

  neverDeleteForNonPayment:true,

};

